import api, {type ApiResponse} from "@/axios.js";
import {defineStore} from 'pinia'
import type {AxiosError} from "axios";

export interface SettingsInterface {
    [key: string]: any | undefined | {}
}

export const useSettingsStore = defineStore('settings', {
    state: () => ({
        _list: [] as SettingsInterface[],
    }),
    getters: {
        list: (state) => state._list,

    },
        actions: {
            async load(): Promise<void> {
                try {
                    const response = await api.get<ApiResponse<SettingsInterface[]>>('/settings');
                    this._list = response.data.data;

                }
                catch (err: AxiosError | any) {
                    throw new Error(err.response?.data?.message || 'An error occurred');
                }
            },
            async update(settings: SettingsInterface) {
                try {
                    const response=await api.post(`/settings`, settings);
                    this._list = response.data.data;
                }
                catch (err: AxiosError | any) {
                    throw new Error(err.response?.data?.message || 'An error occurred');
                }
            },
        }
})